import { InputField } from "@rawa/ui/InputField"
import { TextArea } from "@rawa/ui/TextArea"

const NAME_TAKEN_MESSAGE = "There is already a session template with this name."

/** A template's name and description, as set up and as edited. */
export function SessionTemplateNameFields({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  nameTaken,
}: {
  name: string
  description: string
  onNameChange: (name: string) => void
  onDescriptionChange: (description: string) => void
  nameTaken: boolean
}) {
  return (
    <>
      <InputField
        id="session-template-name"
        label="Template name"
        value={name}
        onChange={onNameChange}
        placeholder="Enter a unique template name"
        error={nameTaken ? NAME_TAKEN_MESSAGE : undefined}
        required
        maxLength={200}
      />

      <TextArea
        id="session-template-description"
        label="Description"
        value={description}
        onChange={onDescriptionChange}
        placeholder="Explain when this template is used"
        required
        maxLength={2000}
      />
    </>
  )
}
